import React, { useEffect, useState  } from "react";
import { Link,useParams } from "react-router-dom"; 
import Header from "./Front/Header";
import Footer from "./Front/Footer";   
import "../styles/global.css";

const PrivicyPolicy = () => {
   
  return (
    <>
       <Header  />
        
  <section className="py-xl-5 py-3">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <nav
            
            aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item"><a href="index.html">Home</a></li>
              <li className="breadcrumb-item active" aria-current="page">Privacy Policy</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </section> 
   <section className="terms-condition section-padding pt-0">
      <div className="container">
        <div className="row">
          <div className="col-12">
            
              <h3>User security</h3>
              <p className="mb-3"><b className="fw-bolder"><a href="https://aceveda.com" target="_blank" rel="noopener noreferrer">aceveda.com</a></b> is totally committed to safeguarding the privacy of our site visitors and customers. We understand and respect the importance of privacy on the internet and have taken all measures to make sure that your personal data is secure with us.</p>
               <h3>User choice on notifications</h3>
              <p className="mb-3">The users are free to opt out of the marketing or other promotional services (sms, email notification or newsletter) from <b className="fw-bolder"><a href="https://aceveda.com" target="_blank" rel="noopener noreferrer">aceveda.com</a></b> at any point of time. </p>
              <h3>Cookies</h3>
              <p className="mb-3">A "cookie" is a computer file that acts as an identification card for your computer. When you visit our site, unique cookies are placed on your browser. We assign a cookie to your computer when you first visit us in order to enable us to recognize you each time you return. Through cookies we can customize our website to your individual preferences in order to create a more personalized, convenient shopping experience. Please note that the cookies we use for our website or email campaigns do not store personally identifiable information about you or your finances. </p>
              <h3>User details sharing</h3>
              <p className="mb-3"><b className="fw-bolder"><a href="https://aceveda.com" target="_blank" rel="noopener noreferrer">aceveda.com</a></b> will never share your personal information with any third parties, its affiliates, partners and other corporate entities. However, from time to time, for <b className="fw-bolder"><a href="https://aceveda.com" target="_blank" rel="noopener noreferrer">aceveda.com</a></b> marketing and transaction notification use affiliates and partners to execute our communication to you. We assure you that strong security measures are deployed to safeguard your information. </p>
              <h3>Right to information</h3>
              <p className="mb-3"><b className="fw-bolder"><a href="https://aceveda.com" target="_blank" rel="noopener noreferrer">aceveda.com</a></b> will require your identity details, contact details, banking information and account history to manage our relationship with you. We assure safety of the information shared by you. </p>
              <h3>Changes in policy</h3>
              <p className="mb-3">We may change this privacy policy at any time by posting the revised privacy policy in the “privacy policy” section of <b className="fw-bolder"><a href="https://aceveda.com" target="_blank" rel="noopener noreferrer">aceveda.com</a></b>. The revised privacy policy is effective immediately when posted on this website. We suggest each user to review the website and the privacy policy periodically to learn of any revisions. Your continued use of <b className="fw-bolder"><a href="https://aceveda.com" target="_blank" rel="noopener noreferrer">aceveda.com</a></b> after the effectiveness of such revisions will constitute your acknowledgment and acceptance of the terms of the revised privacy policy. We will never significantly change our policies and practices to make them less protective of customers. </p>
          </div>
        </div>
      </div>
   </section> 

       <Footer/>
    </>
  );
};

export default PrivicyPolicy;
